import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Link, scroller } from "react-scroll";
// import Common_Btn from "../common/common-btn/Common_Btn";
import "./Header.css";
import Common_Btn from "../common-components/common-btn/Common_Btn";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState("banner");

  const handleNavClick = (section) => {
    setExpanded(false);

    setActiveLink(section);

    if (location.pathname !== "/home") {
      navigate("/home");
      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 500,
          offset: -80,
        });
      }, 300);
    } else {
      scroller.scrollTo(section, {
        smooth: true,
        duration: 500,
        offset: -80,
      });
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    setExpanded(false);
  };

  const closeNavbar = () => setExpanded(false);
  const scrollProps = {
    spy: true,
    smooth: true,
    duration: 100,
    onClick: closeNavbar,
  };

  return (
    <section className="header_section">
      <Navbar
        expand="lg"
        className="bg-body-tertiary p-0"
        collapseOnSelect
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <div className="container-fluid p-0">
          <div className="logo_holder">
            <Navbar.Brand as={Link} to="banner" {...scrollProps}>
              <img
                src="/assets/images/Header-footer/11 DREAMS Logo _ Final-04.png"
                alt="dream_11"
                className="logo_image"
                onClick={() => navigate("/")}
              />
            </Navbar.Brand>
          </div>
          <div className="right_container_holder">
            <div className="strip_1">
              <div className="contact_info">
                <span>
                  <FontAwesomeIcon icon={faEnvelope} /> 11dreams@gmail.com
                </span>
                <span>
                  <FontAwesomeIcon icon={faPhone} /> +91 9876543210
                </span>
              </div>

              <div className="icon_holder_div">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      style={{ color: "#fff", fontSize: "15px" }}
                    />
                  </div>
                </a>
                <a
                  href="https://www.youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon
                      icon={faInstagram}
                      style={{ color: "#fff", fontSize: "15px" }}
                    />
                  </div>
                </a>

                <a
                  href="https://www.youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon
                      icon={faYoutube}
                      style={{ color: "#fff", fontSize: "15px" }}
                    />
                  </div>
                </a>
              </div>
            </div>

            <div className="strip_2">
              <Navbar.Collapse id="main-navbar">
                <Nav>
                  <Nav.Link as={NavLink} to="/" className="nav-link">
                    Home
                  </Nav.Link>

                  <Nav.Link as={NavLink} to="/aboutus" className="nav-link">
                    About Us
                  </Nav.Link>

                  <Nav.Link as={NavLink} to="/contactus" className="nav-link">
                    Contact Us
                  </Nav.Link>

                  <div className="btn_link_holder">
                    <div className="mobile_btn">
                      <Common_Btn
                        btnText="Download Now"
                        onClick={() =>
                          window.open("https://play.google.com", "_blank")
                        }
                      />
                    </div>
                  </div>
                </Nav>
              </Navbar.Collapse>
            </div>
          </div>
          <div className="d-lg-none w-100">
            <div className="mobile_header">
              <Navbar.Brand as={NavLink} to="/" onClick={closeNavbar}>
                <img
                  src="/assets/images/Header-footer/11 DREAMS Logo _ Final-04.png"
                  alt="11_dream"
                  className="logo_image"
                />
              </Navbar.Brand>
              <div className="mobile_btn">
                <Common_Btn
                  btnText="Download Now"
                  onClick={() =>
                    window.open("https://play.google.com", "_blank")
                  }
                />
              </div>

              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>

            <Navbar.Collapse id="mobile-navbar">
              <div className="mobile_menu">
                <Nav className="mobile_nav">
                  <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>
                    Home
                  </Nav.Link>

                  <Nav.Link as={NavLink} to="aboutus" onClick={handleNavClick}>
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="contactus"
                    onClick={handleNavClick}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </div>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>
    </section>
  );
}

export default Header;
